<template>
<div class="login">
</div>
</template>

<script type="text/ecmascript-6">
import { post } from '../api/api'
export default {
  name: 'SsoLogin',
  beforeMount () {
    this.handleToSsoLogin()
  },
  methods: {
    async handleToSsoLogin () {
      const loginid = this.$route.query.loginid
      const token = this.$route.query.token
      const stamp = this.$route.query.stamp
      const loginType = this.$route.query.loginType
      const cusId = this.$route.query.cusId
      const comBrId = this.$route.query.comBrId
      const emAuthUserid = this.$route.query.em_auth_userid
      const result = await post('/api/h5Login', {
        loginid: loginid,
        token: token,
        stamp: stamp,
        loginType: parseInt(loginType),
        systemid: 'mm',
        emAuthUserid: emAuthUserid
      })
      if (result.success) {
        this.$cookies.set('access_token', result.data.access_token, 60 * 60 * 24)
        this.$cookies.set('refresh_token', result.data.refresh_token, 60 * 60 * 24)
        this.$cookies.set('token_type', result.data.token_type, 60 * 60 * 24)
        this.$cookies.set('loginno', result.data.loginno, 60 * 60 * 24)
        this.$cookies.set('actorname', result.data.actorname, 60 * 60 * 24)
        this.$cookies.set('actorno', result.data.actorno, 60 * 60 * 24)
        this.$cookies.set('isGroup', result.data.isGroup, 60 * 60 * 24)
        if (loginType) {
          this.$router.replace({ name: 'pooldetail', params: { cusId, comBrId } })
        } else {
          this.$router.push('/')
        }
      }
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.login
  margin : 50% auto 0
  text-align : center
  .login-btn
    padding : 16px 32px
    outline : none
    border : none
    background : #42b983
    color : #ffffff
    font-size : 32px
</style>
